import { render, staticRenderFns } from "./dividendInfo.vue?vue&type=template&id=d6a483d4"
import script from "./dividendInfo.vue?vue&type=script&lang=js"
export * from "./dividendInfo.vue?vue&type=script&lang=js"
import style0 from "./dividendInfo.vue?vue&type=style&index=0&id=d6a483d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports